enum EventWebPageSectionType {
  BannerSection = 0,
  OrganizerSection = 1,
  CustomSection = 2,
}
export default Object.freeze(EventWebPageSectionType);
